import {DataSource} from "@/datasources/consulte-grid";
import {PatBemModel} from '@/models/patrimonio/patbem/patbem.model';
import PatBemService from "@/services/patrimonio/patbem/patbem.service";

export default class PatBemDataSource extends DataSource<PatBemModel> {
 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: PatBemModel[], onLoad?: (rows: any) => void) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<PatBemModel>())
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await PatBemService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters)).data as any) as DataSource<PatBemModel>;
  console.log(result);
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
